import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as css from '@app/feature/emsp-bo-rfid-badge-order/emsp-bo-rfid-badge-order-details/emsp-bo-rfid-badge-order-details.module.scss';
import { useEmspBoRfidBadgeOrderContext } from '@app/feature/emsp-bo-rfid-badge-order/emsp-bo-rfid-badge-order.context';

export const EmspBoRfidBadgeOrderShippingAddressDetailsController =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { shippingAddress } = useEmspBoRfidBadgeOrderContext();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Card
        className={css.addressCard}
        direction="column"
        gap={GapEnum.M}
        flex={1}>
        <AccentTitle
          icon="file-05"
          as={HeadingEnum.H2}
          text={t(
            'delmonicos-shared-sdk.outputs-rfid-badge-order.shipping-address',
          )}
        />
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.first-name')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.firstName}</Text>
          </Stack>
        </Stack>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.last-name')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.lastName}</Text>
          </Stack>
        </Stack>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.street-address')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.streetAddress}</Text>
          </Stack>
        </Stack>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.zip-code')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.zipCode}</Text>
          </Stack>
        </Stack>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.city')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.city}</Text>
          </Stack>
        </Stack>
        <Stack
          gap={GapEnum.S}
          justifyContent="space-between"
          alignItems="center">
          <Stack flex={1} alignItems="center">
            <Text
              color={TextColor.Secondary}
              uppercase
              fontSize={TextFontSize.Small}>
              {t('delmonicos-shared-sdk.outputs-postal-address.country-code')}
            </Text>
          </Stack>
          <Stack flex={1} alignItems="center">
            <Text>{shippingAddress.countryCode}</Text>
          </Stack>
        </Stack>
        {shippingAddress.phoneNumber && (
          <Stack
            gap={GapEnum.S}
            justifyContent="space-between"
            alignItems="center">
            <Stack flex={1} alignItems="center">
              <Text
                color={TextColor.Secondary}
                uppercase
                fontSize={TextFontSize.Small}>
                {t('delmonicos-shared-sdk.outputs-postal-address.phone-number')}
              </Text>
            </Stack>
            <Stack flex={1} alignItems="center">
              <Text>{shippingAddress.phoneNumber}</Text>
            </Stack>
          </Stack>
        )}
      </Card>
    );
  };
